import { execFileSync } from "node:child_process";
import { win32 } from "node:path";
import { normalizeCommandEnvironment } from "./process-environment.js";
export function resolveWindowsPowerShellPath(env = process.env) {
    const source = normalizeCommandEnvironment(env, "win32");
    const root = source.SystemRoot ?? source.WINDIR;
    if (!(root && win32.isAbsolute(root))) {
        throw new Error("Windows system directory is unavailable.");
    }
    return win32.join(root, "System32", "WindowsPowerShell", "v1.0", "powershell.exe");
}
export function powerShellEncodedArguments(script) {
    return [
        "-NoLogo",
        "-NoProfile",
        "-NonInteractive",
        "-EncodedCommand",
        Buffer.from(script, "utf16le").toString("base64"),
    ];
}
const FILE_TIME_PATTERN = /^\d{10,20}$/u;
// A fresh Windows Service can spend more than five seconds starting its first
// system PowerShell process. Keep the native identity read bounded without
// rejecting that cold start before the script gets a chance to run.
const PROCESS_IDENTITY_TIMEOUT_MS = 15_000;
let currentProcessFileTime;
/** An opened process handle binds the observation to the actual instance, not a reused PID. */
export function readWindowsProcessStartFileTime(pid) {
    if (!(Number.isSafeInteger(pid) && pid > 0)) {
        return null;
    }
    if (pid === process.pid && currentProcessFileTime) {
        return currentProcessFileTime;
    }
    const script = `$ErrorActionPreference='Stop'; $p=[Diagnostics.Process]::GetProcessById(${pid}); try { $null=$p.Handle; [Console]::Write($p.StartTime.ToUniversalTime().ToFileTimeUtc().ToString([Globalization.CultureInfo]::InvariantCulture)) } finally { $p.Dispose() }`;
    try {
        const output = execFileSync(resolveWindowsPowerShellPath(), powerShellEncodedArguments(script), {
            encoding: "utf8",
            windowsHide: true,
            timeout: PROCESS_IDENTITY_TIMEOUT_MS,
            maxBuffer: 1024,
            stdio: ["ignore", "pipe", "ignore"],
        }).trim();
        if (!FILE_TIME_PATTERN.test(output)) {
            return null;
        }
        if (pid === process.pid) {
            currentProcessFileTime = output;
        }
        return output;
    }
    catch {
        return null;
    }
}
